import React from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import CustomButton from "Components/Custom/CustomButton";
import { useAppDispatch } from "Components/Hooks/hooks";
import { useFormik } from "formik";
import { CategoryType } from "pages/Settings/Cards/Categories";
import * as Yup from "yup";
import { manageCategory } from "slices/thunks";
import {
  VALIDATION_LIMITS,
  VALIDATION_MESSAGES,
  createNameValidation,
} from "Components/constants/validation";

interface AddCategoryModalProps {
  show: boolean;
  onCloseClick: () => void;
}

const AddCategoryModal: React.FC<AddCategoryModalProps> = ({
  show,
  onCloseClick,
}) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    if (validation.errors.categoryName || validation.errors.id) {
      return;
    }
    // onCloseClick();
  };

  const handleForceClose = () => {
    validation.resetForm();
    onCloseClick();
  };

  const validation = useFormik<CategoryType>({
    enableReinitialize: true,
    initialValues: {
      categoryName: "",
    },
    validationSchema: Yup.object({
      categoryName: Yup.string()
        .trim()
        .required(VALIDATION_MESSAGES.REQUIRED("category name"))
        .min(
          VALIDATION_LIMITS.NAME.MIN,
          VALIDATION_MESSAGES.MIN_LENGTH(
            "Category Name",
            VALIDATION_LIMITS.NAME.MIN
          )
        )
        .max(
          VALIDATION_LIMITS.NAME.MAX,
          VALIDATION_MESSAGES.MAX_LENGTH(
            "Category Name",
            VALIDATION_LIMITS.NAME.MAX
          )
        )
        .test(
          "valid-category-name",
          createNameValidation("Category Name").message,
          createNameValidation("Category Name").test
        ),
    }),
    onSubmit: (values) => {
      dispatch(
        manageCategory({
          name: values.categoryName?.trim(),
        })
      );
      onCloseClick();
      validation.resetForm();
    },
  });

  return (
    <Offcanvas
      direction="end"
      isOpen={show}
      id="offcanvasExample"
      toggle={handleForceClose}
    >
      <OffcanvasHeader className="bg-greyF5" toggle={handleForceClose}>
        Add Category
      </OffcanvasHeader>

      <form
        className="h-100  d-flex flex-column justify-content-between"
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
        }}
      >
        <div className="mb-3 p-3">
          <Label
            htmlFor="customer-name"
            className="font-primary fw-normal fs-14 text-black2D d-flex"
          >
            Category Name
          </Label>
          <Input
            type="text"
            className="auth-form-control"
            id="customer-name"
            placeholder="Category Name"
            name="categoryName"
            value={validation.values.categoryName}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            invalid={
              !!validation.touched.categoryName &&
              !!validation.errors.categoryName
            }
          />
          {validation.touched.categoryName &&
            validation.errors.categoryName && (
              <FormFeedback>{validation.errors.categoryName}</FormFeedback>
            )}
        </div>
        <div className="offcanvas-footer border-top p-3 text-center hstack gap-2">
          <CustomButton
            type="submit"
            text="Save Category"
            className="bg-primary w-100 br-7"
            onClick={handleClose}
          />
        </div>
      </form>
    </Offcanvas>
  );
};

export default AddCategoryModal;
